import { render } from "./dealerInquiry.vue?vue&type=template&id=2d6c9b44&scoped=true"
import script from "./dealerInquiry.vue?vue&type=script&lang=js"
export * from "./dealerInquiry.vue?vue&type=script&lang=js"

import "./dealerInquiry.vue?vue&type=style&index=0&id=2d6c9b44&lang=scss&scoped=true"

import exportComponent from "/Users/jinjing/Desktop/jj/code1/HM0518/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6c9b44"]])

export default __exports__